<template>
  <q-row :gutter="10">
    <q-form
      ref="postDetail"
      :model="post"
      :rules="rangeRules"
      label-width="20px"
      label-position="top"
    >
      <q-col :span="6">
        <q-panel
          :header-text="this.$qt('post.detail.data.title')"
          class="panel"
        >
          <div class="panel-padding">
            <q-form-item
              :label="this.$qt('post.detail.data.categoryTitle')"
              prop="category"
            >
              <q-select v-model="post.category">
                <q-option
                  v-for="category in categories"
                  :key="category.key"
                  :label="category.title"
                  :value="category.key"
                />
              </q-select>
            </q-form-item>
            <q-form-item
              :label="this.$qt('post.detail.data.bgColorTitle')"
              prop="bgColor"
            >
              <q-color-picker
                v-model="post.bgColor"
                :placeholder="this.$qt('post.detail.data.bgColorPlaceholder')"
              />
            </q-form-item>
            <q-form-item
              :label="this.$qt('post.detail.data.colorTitle')"
              prop="color"
            >
              <q-color-picker
                v-model="post.color"
                :placeholder="this.$qt('post.detail.data.colorPlaceholder')"
              />
            </q-form-item>
            <q-form-item
              :label="this.$qt('post.detail.data.tagsTitle')"
              prop="tags"
            >
              <q-select
                v-model="post.tags"
                multiple
                filterable
                allow-create
                default-first-option
                :placeholder="this.$qt('post.detail.data.tagsPlaceholder')"
              >
                <q-option
                  v-for="item in tags"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </q-select>
            </q-form-item>
            <q-form-item
              :label="this.$qt('post.detail.data.thumbnailTitle')"
              prop="thumbnail"
            >
              <q-upload type="image" v-model="post.thumbnail" />

              <img
                v-if="post.thumbnail"
                :src="post.thumbnail"
                width="200px"
                alt=""
              >
            </q-form-item>
            <q-form-item
              :label="this.$qt('post.detail.data.imageTitle')"
              prop="image"
            >
              <q-upload type="image" v-model="post.image" />

              <img
                v-if="post.image"
                :src="post.image"
                width="200px"
                alt=""
              >
            </q-form-item>
            <div v-if="post.seo !== undefined">
              <q-form-item
                :label="this.$qt('post.detail.data.seoTitle')"
                prop="seoTitle"
              >
                <q-input
                  v-model="post.seo.title"
                  :placeholder="this.$qt('post.detail.data.seoTitlePlaceholder')"
                />
              </q-form-item>

              <q-form-item
                :label="this.$qt('post.detail.data.seoDescriptionTitle')"
                prop="seoDescription"
              >
                <q-input
                  v-model="post.seo.description"
                  type="textarea"
                  :rows="4"
                  :placeholder="this.$qt('post.detail.data.seoDescriptionPlaceholder')"
                />
              </q-form-item>

              <q-form-item
                :label="this.$qt('post.detail.data.seoKeywordsTitle')"
                prop="seoKeywords"
              >
                <q-input
                  v-model="post.seo.keywords"
                  type="textarea"
                  :rows="6"
                  :placeholder="this.$qt('post.detail.data.seoKeywordsPlaceholder')"
                />
              </q-form-item>
            </div>
          </div>
        </q-panel>
      </q-col>
      <q-col :span="18">
        <q-panel
          :header-text="this.$qt('post.detail.generalTitle')"
          class="panel"
        >
          <div class="panel-padding">
            <q-form-item
              prop="title"
            >
              <q-input
                v-model="post.title"
                :disabled="false"
                :placeholder="this.$qt('post.detail.titlePlaceholder')"
              />
            </q-form-item>
            <q-form-item
              prop="textType"
            >
              <q-select
                v-model="post.textType"
              >
                <q-option
                  :label="this.$qt('post.detail.textType.marked')"
                  value="Marked"
                />
                <q-option
                  :label="this.$qt('post.detail.textType.html')"
                  value="Html"
                />
                <q-option
                  :label="this.$qt('post.detail.textType.text')"
                  value="Text"
                />
              </q-select>
            </q-form-item>
            <q-form-item
              prop="text"
            >
              <template v-if="post.textType === 'Marked'">
                <q-input
                  v-model="post.text"
                  dir="ltr"
                  type="textarea"
                  :rows="25"
                  :placeholder="this.$qt('post.detail.markedContentPlaceholder')"
                />
              </template>
              <template v-else-if="post.textType === 'Html'">
                <q-input
                  v-model="post.text"
                  dir="ltr"
                  type="textarea"
                  :rows="25"
                  :placeholder="this.$qt('post.detail.htmlContentPlaceholder')"
                />
              </template>
              <template v-else>
                <q-input
                  v-model="post.text"
                  type="textarea"
                  :rows="25"
                  :placeholder="this.$qt('post.detail.textContentPlaceholder')"
                />
              </template>
            </q-form-item>
            <q-form-item
              :label="this.$qt('post.detail.summaryTitle')"
              prop="summary"
            >
              <q-input
                v-model="post.summary"
                type="textarea"
                :rows="4"
                :disabled="false"
                :placeholder="this.$qt('post.detail.summaryPlaceholder')"
              />
            </q-form-item>
            <div
              v-show="!readonly"
              slot="footer"
            >
              <q-button
                type="primary"
                @click="persist()"
              >
                <span>{{ $qt('model.okButtonText') }}</span>
              </q-button>
<!--              <q-button-->
<!--                v-show="!readonly"-->
<!--                @click="reject()"-->
<!--              >-->
<!--                <span>{{ $qt('model.rejectButtonText') }}</span>-->
<!--              </q-button>-->
<!--              <q-button-->
<!--                v-show="!readonly"-->
<!--                type="danger"-->
<!--                @click="deleteModel()"-->
<!--              >-->
<!--                <span>{{ $qt('model.deleteButtonText') }}</span>-->
<!--              </q-button>-->
            </div>
          </div>
        </q-panel>
<!--        <q-form-item-->
<!--          prop="comments"-->
<!--        >-->
<!--          <q-composite-list-->
<!--            v-model="post.comment"-->
<!--            structure-key="comment"-->
<!--          />-->
<!--        </q-form-item>-->
      </q-col>
    </q-form>
  </q-row>
</template>

<script>

  import marked from 'marked'
  import caller from '../../../q-components/q-caller';

  import upload from "../../../components/upload";

  export default {
    name: "QPostDetail",
    components: {
      'q-upload': upload,
    },

    data() {
      return {
        tags: [
          {key: 'java', value: 'java'},
          {key: 'java-topics', value: 'java-topics'},
          {key: 'java-concurrency', value: 'java-concurrency'},
          {key: 'rust', value: 'rust'},
          {key: 'c', value: 'c'},
          {key: 'architecture', value: 'architecture'},
        ],
        categories: [],
        readonly: false,
        post: {},
        rangeRules: {
          title: [
            {required: true, message: 'عنوان را وارد کنید', trigger: 'blur'},
          ],
        }
      }
    },

    computed: {
      compiledMarkdown() {
        if (this.post.text)
          return marked(this.post.text, {sanitize: true});
        else
          return '';
      }
    },

    watch: {},

    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize());
    },

    methods: {
      initialize() {
        caller.delegate('edms', 'getContentAsEditablePost', {
          id: ''
        }).then((res) => {
          caller.delegate('edms', 'getCategoriesForBlogList', {
            archive: 'blog'
          }).then((res1) => {

            caller.delegate('parameter', 'getAllItems', {
              parameterKey: 'CONTENT_TAG'
            }).then((res2) => {

              this.categories = res1.result.categories;
              this.post = res.result;
              this.tags = res2.result.items;

              this.$eventHub.$emit("onPageChanging", {
                caption: 'this.formStructure.caption',
                note: 'this.formStructure.note'
              })

            }).catch(() => {
            });

          }).catch(() => {
          });
        }).catch(() => {
        });
      },

      persist() {
        this.$refs['postDetail'].validate((valid) => {
          if (valid) {
            this.$delegate('edms', 'persistPost', {
              post: this.post
            }).then((result) => {
              this.$notify({
                title: this.$qt('model.successPersistTitle'),
                message: result.message,
                type: 'success'
              });
              this.readonly = true;
            }).catch(() => {
            });
          } else {
            this.$notify({
              title: this.$qt('notify.exceptionTitle'),
              message: this.$qt('validation.completeFormMessage'),
              type: 'success'
            });
            return false;
          }
        });
      },
    }
  }

</script>

<style scoped>

  .panel{
  }


</style>